export const skinThemeStyleMap = {
  standard: {
    background: "#1989fa",
    color: "#fff",
    modal: true,
    companyName: "#fff",
    todo: "#fff",
    svg: "#fff"
  },
  simple: {
    background: "#fff",
    color: "#606266",
    modal: false,
    companyName: "#606266",
    todo: "#535c65",
    svg: "#C0C4CC"
  }
}
